<div class="page-section">
    <p class="file-upload-heading">Upload your File</p>
    <div class="file-upload-section">
        <p class="each-upload-file-name">{{uploaded_file_name}}</p>
        <input type="file" style="display: none" #upload_input (change)="uploadFile($event)" />
        <button class="each-upload-button" *ngIf="!upload_file_loader" (click)="upload_input.click()" >
            <img src="assets/file-upload.png" class="each-upload-button-icon" />
            <span>Upload</span>
        </button>
        <button class="each-upload-button" *ngIf="upload_file_loader">
            <img src="assets/file-upload.png" class="each-upload-button-icon" />
            <span>Uploading ...</span>
        </button>
    </div>
</div>